import { Button, Grid, Typography as MuiTypography } from "@mui/material";
import React, { useEffect } from "react";
import styled from "@emotion/styled";

const Title = styled(MuiTypography)`
  font-family: SofiaProSemiBold;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 112%;
  text-align: center;
  margin-bottom: 1rem;
`;

export default function Form8SignUpStep1({ onSubmit }) {
  useEffect(function () {
    setTimeout(function () {
      onSubmit();
    }, 5000);
  }, []);

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Title>Success!</Title>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="center">
          <MuiTypography fontWeight="bold" textAlign="center" maxWidth={340}>
            Thank you for answering our questions! One of our Customer Success
            Representatives will send you an email with the next steps.
          </MuiTypography>
        </Grid>
      </Grid>
    </div>
  );
}
